
import FileMeta from './file-meta.vue';
import FrameSequence from '@/components/FrameSequence/index.vue';

export default {
  components: {
    FileMeta: FileMeta,
    FrameSequence: FrameSequence
  },

  props: {
    images: {
      type: Array,
      required: true
    },
    frameSequenceStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    frameSequenceContainerStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    fileMeta: {
      type: Object
    },
    fileMetaStyle: {
      type: Object
    },
    initKeyFramesOnMounted: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {};
  }
};